import React, { useEffect, useRef } from 'react';
import { useAuthentication } from "meportal/AuthenticationProvider";
import { getFleetTypes } from '../../../services/otsEventService';
import { NOTIFICATION_TYPES } from "../../ToastNotification/toastConstants";
import "@aurodesignsystem/auro-select";
import { useToast } from '../../../providers/ToastProvider';
import './OTSFleetEventDetails.scss';


interface FleetTypeDropdownProps {
    onFleetTypeChange: (fleet: string) => void;
}

const FleetTypeDropdown: React.FC<FleetTypeDropdownProps> = ({ onFleetTypeChange }) => {
    const { userData, getLatestAccessToken } = useAuthentication();
    const fleetTypesRef = useRef(null);
    const [fleetTypes, setFleetTypes] = React.useState([]);
    const [fleet, setFleet] = React.useState<string | null>(null);
    const { addToast } = useToast();

    const handleEventTypeSelectedOption = (elem: any) => {
        const selectedFleet = elem.target.value;
        setFleet(selectedFleet);
        onFleetTypeChange(selectedFleet);
    }

    useEffect(() => {
        try {
            getLatestAccessToken().then((token: any) => {
                userData.access_token = token;
                getFleetTypes(userData).then((fleetType) => {
                    setFleetTypes(fleetType);
                });
            });
        } catch (error) {
            console.log("Error occurred while fetching fleet event type")
            addToast(NOTIFICATION_TYPES.WARNING, "Error occurred while fetching fleet types");
        }
    }, [userData]);

    useEffect(() => {
        const control = fleetTypesRef.current;

        if (control) {
            control.addEventListener('selectedOption', handleEventTypeSelectedOption);
        }

        // Clean up function
        return () => {
            if (control) { control.removeEventListener('selectedOption', handleEventTypeSelectedOption); }
        };
    }, [fleetTypes]);

    return (
        <auro-select class="fleet-type-dropdown" placeholder="Fleet" value={fleet} ref={fleetTypesRef} data-testid="fleet-Type"
        required
        setCustomValidityValueMissing="A selection is required">
            {fleet && fleet.length > 0 && <span slot="label">Fleet</span>}
            <auro-menu class="fleet-type-dropdown">
                {Array.isArray(fleetTypes) &&
                    fleetTypes?.map((item: any) => (
                        <auro-menuoption  class="fleet-type-dropdown" value={item.FleetType}
                            key={item.FleetType}
                            id={item.FleetType}
                        >{item.FleetType}</auro-menuoption>
                    ))
                }
            </auro-menu>
        </auro-select>
    );
};

export default FleetTypeDropdown;